// extracted by mini-css-extract-plugin
module.exports = {"sp-175w-A":"A_sp-175w-A__cFhj_"};